import { useEffect } from 'react'

const Links = () => {
    useEffect(() => {
        window.location.replace("https://monotein.com/books/mern-book")
    }, [])
    return <></>
}

export default Links
